import { Box } from '@mui/material';
import { FC } from 'react';
import Lottie from "lottie-react";
import loaderAnimation from 'shared/assets/animations/LoadingVerify.json';

interface ILoaderLoaderVerify {
    title: string;
}

export const LoaderVerify: FC<ILoaderLoaderVerify> = ({title}) => {
    return (
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', flexDirection: "column" }}>
            <Lottie
                animationData={loaderAnimation}
                loop={true}
                autoplay={true}
                style={{ width: 300, height: 300 }}
            />
            <p style={{ color: '#0054E6', fontSize: '20px', marginTop: '-60px' }}>{title}</p>
        </Box>
    );
};

export default LoaderVerify;
